import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ReferralProgramConfig = () => {
  const [referralSettings, setReferralSettings] = useState({
    referrerBonus: 100,
    refereeBonus: 50,
    milestoneBonus: 250,
    milestoneCount: 5
  });

  return (
    <div className="space-y-6">
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Referral Program Configuration
        </h2>
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Input
                label="Referrer Bonus Points"
                type="number"
                defaultValue={referralSettings?.referrerBonus}
                description="Points awarded to member who refers"
              />
            </div>
            <div>
              <Input
                label="Referee Welcome Bonus"
                type="number"
                defaultValue={referralSettings?.refereeBonus}
                description="Points awarded to new member"
              />
            </div>
            <div>
              <Input
                label="Milestone Bonus"
                type="number"
                defaultValue={referralSettings?.milestoneBonus}
                description="Bonus for reaching referral milestone"
              />
            </div>
            <div>
              <Input
                label="Milestone Count"
                type="number"
                defaultValue={referralSettings?.milestoneCount}
                description="Number of referrals for milestone"
              />
            </div>
          </div>
          <Button iconName="Save">
            Save Configuration
          </Button>
        </div>
      </div>

      {/* Success Rate Optimization */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Success Rate & A/B Testing
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 rounded-lg bg-primary/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Users" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">Total Referrals</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">342</p>
            <p className="text-xs text-success">+18% vs last month</p>
          </div>
          <div className="p-4 rounded-lg bg-success/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="CheckCircle" size={20} color="var(--color-success)" />
              <span className="text-sm font-medium text-foreground">Conversion Rate</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">68.5%</p>
            <p className="text-xs text-success">+5.2% improvement</p>
          </div>
          <div className="p-4 rounded-lg bg-accent/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="TrendingUp" size={20} color="var(--color-accent)" />
              <span className="text-sm font-medium text-foreground">Avg. Referrals/Member</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">2.3</p>
            <p className="text-xs text-muted-foreground">Active referrers</p>
          </div>
        </div>
      </div>

      {/* A/B Testing */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          A/B Testing Campaigns
        </h2>
        <p className="text-sm text-muted-foreground mb-4">
          Test different referral incentive structures to optimize conversion
        </p>
        <div className="space-y-3">
          <div className="p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-medium text-foreground">Campaign A: Standard Bonus</h3>
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-primary/20 text-primary">
                Active
              </span>
            </div>
            <p className="text-sm text-muted-foreground mb-2">100 pts referrer / 50 pts referee</p>
            <div className="flex items-center gap-4 text-sm">
              <span className="text-muted-foreground">Conversion: <strong className="text-foreground">65%</strong></span>
              <span className="text-muted-foreground">Sample: <strong className="text-foreground">156 referrals</strong></span>
            </div>
          </div>
          <div className="p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-medium text-foreground">Campaign B: Enhanced Bonus</h3>
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-success/20 text-success">
                Testing
              </span>
            </div>
            <p className="text-sm text-muted-foreground mb-2">150 pts referrer / 75 pts referee</p>
            <div className="flex items-center gap-4 text-sm">
              <span className="text-muted-foreground">Conversion: <strong className="text-foreground">72%</strong></span>
              <span className="text-muted-foreground">Sample: <strong className="text-foreground">89 referrals</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralProgramConfig;